const WHATSAPP_URL = 'https://wa.me/5579999778899';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#173A4D]">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/f1b3a4175f8a22f2b553a2df5776ff9e.png"
              alt="Diogo de Calasans Melo Andrade Advogado"
              className="h-16 w-auto object-contain mb-5"
            />
            <h2 className="text-white font-600 text-base mb-1">
              Diogo de Calasans Melo Andrade
            </h2>
            <p className="text-white/60 text-sm mb-1">Sociedade Individual de Advocacia</p>
            <p className="text-white/40 text-xs mb-6">CNPJ: 53.826.804/0001-00</p>
            <p className="text-white/70 text-sm leading-relaxed max-w-xs">
              Consultoria estratégica com análise técnica, segurança jurídica e atendimento personalizado em Aracaju, Sergipe.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-600 text-sm tracking-wide mb-6">
              <a href="#hero" id="navegacao">Navegação</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Início', href: '#hero' },
                { label: 'Sobre o Advogado', href: '#sobre' },
                { label: 'Consultoria Jurídica', href: '#consultoria' },
                { label: 'Diferenciais', href: '#diferenciais' },
                { label: 'Como Funciona', href: '#como-funciona' },
                { label: 'Contato', href: '#contato' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector(item.href);
                      if (el) {
                        const top = (el as HTMLElement).getBoundingClientRect().top + window.scrollY - 80;
                        window.scrollTo({ top, behavior: 'smooth' });
                      }
                    }}
                    className="text-white/60 hover:text-[#D4A873] text-sm transition-colors duration-200 cursor-pointer"
                    rel="nofollow"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-600 text-sm tracking-wide mb-6">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-2-line text-[#C6935A] text-base mt-0.5 flex-shrink-0" />
                <p className="text-white/60 text-sm leading-relaxed">
                  Av. Ministro Geraldo Barreto Sobral, 162, sala 5<br />
                  Grageru – Aracaju/SE<br />
                  CEP 49027-255
                </p>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-[#C6935A] text-base flex-shrink-0" />
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/60 hover:text-[#D4A873] text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  (79) 99977-8899
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-[#C6935A] text-base flex-shrink-0" />
                <a
                  href="mailto:contato@profdiogocalasans.org"
                  className="text-white/60 hover:text-[#D4A873] text-sm transition-colors cursor-pointer"
                >
                  contato@profdiogocalasans.org
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#C6935A]/20">
        <div className="max-w-7xl mx-auto px-6 py-7 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs text-center md:text-left">
            &copy; {year} Diogo de Calasans Melo Andrade Sociedade Individual de Advocacia. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 hover:text-white/60 text-xs transition-colors cursor-pointer whitespace-nowrap">
              Termos de Uso
            </a>
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-white/60 text-xs transition-colors cursor-pointer whitespace-nowrap"
            >
              Desenvolvido por Start Digital
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
